import { create } from '@storybook/theming';

export default create({
  base: 'light',

  colorPrimary: '#1999e3', //@color-primary
  colorSecondary: '#1999e3', //@color-primary

  // UI
  appBg: '#e5ebef', //@background-dark
  appContentBg: '#fff;',
  appBorderColor: '#c9d7df', //@border
  appBorderRadius: 4,

  // Typography
  fontBase:
    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Helvetica, Arial, sans-serif',
  fontCode: 'Consolas, Menlo, Courier New, Courier, monospace',

  // Text colors
  textColor: '#283542', //@color-darkest
  textInverseColor: 'rgba(255,255,255,0.9)',

  // Toolbar default and active colors
  barTextColor: '#283542', //@color-darkest
  barSelectedColor: '#1999e3', //@color-primary
  barBg: 'white',

  // Form colors
  inputBg: 'white',
  inputBorder: '#c9d7df', //@border
  inputTextColor: '#283542', //@color-darkest
  inputBorderRadius: 4,

  brandTitle: 'Recruitee DS',
  brandUrl: 'https://recruitee.design',
  brandImage: './images/recruitee-logo.svg',
});
